import { useSortable } from '@dnd-kit/sortable';
import { ListIcon } from '@phosphor-icons/react';
import { CSS } from '@dnd-kit/utilities';
import { TagFamilyMemberType } from '../../../../../schemas/index';
import TagNodeEditor from './TagNodeEditor';

function SortableTagNode({
  id,
  node,
  path,
  onChange,
  onDelete,
  onAddChild,
  onSort,
  level = 0,
}: {
  id: string;
  node: TagFamilyMemberType;
  path: Array<number>;
  onChange: (path: Array<number>, newNode: TagFamilyMemberType) => void;
  onDelete: (path: Array<number>) => void;
  onAddChild: (path: Array<number>, child: TagFamilyMemberType) => void;
  onSort: (path: Array<number>, newNodes: Array<TagFamilyMemberType>) => void;
  level?: number;
}) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    paddingRight: '16px',
  };

  return (
    <div ref={setNodeRef} style={style}>
      <TagNodeEditor
        node={node}
        path={path}
        onChange={onChange}
        onDelete={onDelete}
        onAddChild={onAddChild}
        onSort={onSort}
        sortableHandle={
          <span {...attributes} {...listeners} style={{ cursor: 'grab' }}>
            <ListIcon />
          </span>
        }
        level={level}
      />
    </div>
  );
}

export default SortableTagNode;
